module.exports = __webpack_public_path__ + "media/images/thumbs/physanims/a2-0-52bc6b23d8170c359a155420e31950ea.jpg";